import { ENEMY_DEFINITIONS } from "../data/enemies"
import type { SectorBossDef } from "../data/sectors"

export interface BossEncounterStats {
  hp: number
  damage: number
  points: number
  shootCooldown: number
}

export function resolveBossEncounterStats(
  bossDef: SectorBossDef,
): BossEncounterStats {
  const enemyDef = ENEMY_DEFINITIONS[bossDef.type]

  return {
    hp: bossDef.hp,
    damage: enemyDef.damage * bossDef.damageMultiplier,
    points: enemyDef.points * bossDef.pointsMultiplier,
    shootCooldown: enemyDef.shootCooldown,
  }
}
